<template>
    <span v-if="this.paymentStatus === 'ATTESA'">
        {{$t('pagamento_attesa')}}
    </span>
    <span v-else-if="this.paymentStatus === 'PAGATO'">
        {{$t('pagamento_pagato')}}
    </span>
    <span v-else-if="this.paymentStatus === 'FALLITO'">
        {{$t('pagamento_fallito')}}
    </span>
    <span v-else>N/A</span>
</template>

<script>
export default {
    name: "IncOrderPaymentStatus",
    props: ['paymentStatus']
}
</script>
